<template>
<div class="container">
  <div class="col-sm-8 m-sm-auto col-md-5 m-md-auto">
    <h2 class="text-center py-3 py-sm-5">パスワード再発行</h2>

    <p class="alert alert-info">入力頂いたメールアドレス宛に、新しい仮パスワードをお送りいたします。<br> メールアドレスを間違えている場合など、メールが届かない場合があります。メールが届かない場合は、システムに登録しているメールアドレスをご確認の上、再度入力して下さい。</p>
    <form action="" class="form-group">
      <div class="form-group">
        <label for="email" class="sr-only">メールアドレス</label>
        <input type="mail" class="form-control" placeholder="メールアドレス" id="email" v-model="email">
      </div>
      <a class="btn btn-primary btn-block mb-5" :class="submitStyle" href="#" title="" @click.prevent="submit()">パスワード再発行</a>
      <p v-if="message">{{ message }}</p>
      <router-link class="btn btn-secondary btn-block mb-5" to="/login" title="">ログイン画面へ戻る</router-link>
    </form>
  </div>
</div>
</template>

<script>
import util from 'util/lecturer'
import api from 'api'
import modal from 'util/modal'
export default {
  data () {
    return {
      email: '',
      message: ''
    }
  },
  computed: {
    isEmailValid () {
      return this.email && util.validateEmail(this.email)
    },
    submitStyle () {
      return this.isEmailValid ? '' : 'disabled'
    }
  },
  methods: {
    submit () {
      if (!this.isEmailValid) { return }
      api.resetPassword(this, { email: this.email }).then(msg => {
        this.message = msg.message
      }).catch(err => {
        modal.showErrorModal(this, err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Password.vue?5037c41c